export const TRANSACTIONS_VAT_DIFFERENCE = 'transactions_vat_difference';
